import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FloatingButtons.css';

/**
 * Componente FloatingButtons - Botones flotantes de WhatsApp y Calendario
 * Migrado del CSS original manteniendo todas las animaciones
 */
const FloatingButtons: React.FC = () => {
  const navigate = useNavigate();
  const [showBookingHint, setShowBookingHint] = useState(false);

  useEffect(() => {
    const target = document.getElementById('como-agendar');
    if (!target || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      ([entry]) => setShowBookingHint(entry.isIntersecting),
      { threshold: 0.3 }
    );
    observer.observe(target);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="floating-buttons">
      {/* Botón de WhatsApp */}
      <a
        href="https://wa.me/56978009119?text=Hola,%20me%20gustaría%20agendar%20una%20consulta%20en%20Conectemos%20Chile"
        className="whatsapp-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chatea con nosotros por WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
        <span className="floating-tooltip">¿Necesitas ayuda? ¡Agenda tu consulta!</span>
      </a>

      {/* Botón de Calendario — lleva al sistema propio de agendamiento */}
      <button
        className="calendar-btn"
        aria-label="Agendar hora en Conectemos Chile"
        onClick={() => navigate('/agendar')}
      >
        <i className="far fa-calendar-alt"></i>
        <span className="floating-tooltip">Agendar hora</span>
        {showBookingHint && (
          <span className="calendar-hint" aria-hidden="true">
            <span className="calendar-hint__emoji">🙋</span>
            <span className="calendar-hint__text">¡Agendá aquí!</span>
          </span>
        )}
      </button>
    </div>
  );
};

export default FloatingButtons;